import { useState } from "react";
import AccountNSetting from "../Modals/AccountNSetting";
import EditName from "../Modals/EditName";
import ResetPassword from "../Modals/ResetPassword";
import SetAdmin from "../Modals/SetAdmin";
import SetLogo from "../Modals/SetLogo";
import "../Styles/global.css";
import Header from "./Header";
import NavBar from "./NavBar";
import SetNickname from "../Modals/SetNickname";

const Layout = ({ page }) => {
  const [clickAccountNSetting, setClickAccountNSetting] = useState(false);
  const [clickEditName, setClickEditName] = useState(false);
  const [clickResetPW, setClickResetPW] = useState(false);
  const [clickSetLogo, setClickSetLogo] = useState(false);
  const [clickSetNickname, setClickSetNickname] = useState(false);
  const [clickSetAdmin, setClickSetAdmin] = useState(false);

  const handleClickX = () => {
    setClickAccountNSetting(false);
    setClickResetPW(false);
    setClickSetLogo(false);
    setClickSetNickname(false);
    setClickSetAdmin(false);
  };

  const openResetPassword = () => {
    setClickAccountNSetting(false);
    setClickResetPW(true);
  };

  const closeResetPassword = () => {
    setClickResetPW(false);
    setClickAccountNSetting(true);
  };

  return (
    <div className="page-wrapper">
      {clickAccountNSetting && (
        <AccountNSetting
          handleClickX={() => setClickAccountNSetting(false)}
          handleClickEditName={() => setClickEditName(true)}
          handleClickResetPW={openResetPassword}
          handleClickSetLogo={() => setClickSetLogo(true)}
          handleClickSetNickname={() => setClickSetNickname(true)}
          handleClickSetAdmin={() => setClickSetAdmin(true)}
        />
      )}
      {clickEditName && (
        <EditName handleClickX={() => setClickEditName(false)} />
      )}
      {clickResetPW && (
        <ResetPassword
          handleClickBack={closeResetPassword}
          handleClickX={handleClickX}
        />
      )}
      {clickSetLogo && (
        <SetLogo
          handleClickBack={() => setClickSetLogo(false)}
          handleClickX={() => handleClickX()}
        />
      )}
      {clickSetNickname && (
        <SetNickname
          handleClickBack={() => setClickSetNickname(false)}
          handleClickX={() => handleClickX()}
        />
      )}
      {clickSetAdmin && (
        <SetAdmin
          handleClickBack={() => setClickSetAdmin(false)}
          handleClickX={() => handleClickX()}
        />
      )}

      <Header handleClick_setting={() => setClickAccountNSetting(true)} />
      <div style={{ display: "flex" }}>
        <NavBar />
        <div className="page-content">{page}</div>
      </div>
    </div>
  );
};

export default Layout;
